export default __webpack_public_path__ + "static/media/select-pay-token.54548a27.svg";